import { useCompanyInfo } from "@/api/services/main/company";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { convertResToFormData } from "@/features/company/utiles/convertCompanyFormData";
import { CompanyDetailContent } from "@/features/company/components/company-detail/CompanyDetailContent";
import { useValidateId } from "@/hooks/useValidateId";
import { AppRoutes } from "@/routes/config";

const CompanyDetailPage = () => {
  const queryResult = useCompanyInfo();
  const { data, isLoading } = queryResult;
  useValidateId("companyId", AppRoutes.companyList, queryResult);

  if (!data || isLoading) return <LoadingPage />;

  return <CompanyDetailContent defaultValues={convertResToFormData(data.data)} />;
};

export default CompanyDetailPage;
